import { useWorkspace } from '../../../contexts/WorkspaceContext';
import { PermissionKey } from '../../../types/workspace';

export function usePermissions(_: string) {
  const { workspace } = useWorkspace();
  const canViewPerformance = workspace?.permissions[PermissionKey.CAN_VIEW_BLUEPRINT_PERFORMANCE] ?? false;

  const permissions = {
    canPublish: true,
    canArchive: true,
    canSetAsStandard: true,
    canEdit: true,
    canCreate: true,
    BLUEPRINT_VIEW: true,
    BLUEPRINT_EDIT: true,
    BLUEPRINT_PUBLISH: true,
    BLUEPRINT_ARCHIVE: true,
    BLUEPRINT_SET_STANDARD: true,
    BLUEPRINT_COMPARE: true,
    BLUEPRINT_VIEW_LOGS: true,
    BLUEPRINT_VIEW_PERFORMANCE: canViewPerformance,
  } as const;

  return { permissions, loading: false, error: undefined } as const;
}
